webpackJsonp([133616086578729],{

/***/ 149:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"successGradient":"src-components-Cleanings----cleaning-module---successGradient---2B6Ks","resetZIndex":"src-components-Cleanings----cleaning-module---resetZIndex---1dCyk","messageFlex":"src-components-Cleanings----cleaning-module---messageFlex---3wVmn"};

/***/ }),

/***/ 755:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(132);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _semanticUiReact = __webpack_require__(20);
	
	var _cleaningModule = __webpack_require__(149);
	
	var _cleaningModule2 = _interopRequireDefault(_cleaningModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FreeCleanings = function (_Component) {
	  _inherits(FreeCleanings, _Component);
	
	  function FreeCleanings() {
	    _classCallCheck(this, FreeCleanings);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  FreeCleanings.prototype.render = function render() {
	    return _react2.default.createElement(
	      "div",
	      { className: _cleaningModule2.default.successGradient },
	      _react2.default.createElement(
	        _semanticUiReact.Container,
	        { style: { paddingTop: "15vh" }, text: true },
	        _react2.default.createElement(
	          _semanticUiReact.Grid,
	          null,
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Row,
	            null,
	            _react2.default.createElement(
	              _semanticUiReact.Grid.Column,
	              null,
	              _react2.default.createElement(
	                _semanticUiReact.Segment,
	                { fluid: true, raised: true },
	                _react2.default.createElement(
	                  "h2",
	                  null,
	                  "Coming soon - Get a free cleaning by referring your friends!"
	                )
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return FreeCleanings;
	}(_react.Component);
	
	exports.default = FreeCleanings;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-freecleanings-jsx-dff16229fc95c9afb50f.js